export const configureOmiseSDK = () => {
	const omisePublicKeyUAT = process.env.REACT_APP_OMISE_PKEY_UAT;
	const omisePublicKeyPROD = process.env.REACT_APP_OMISE_PKEY_PROD;

	const currentUrl = window.location.href;

	if (currentUrl.includes("learn.sda.edu.sg")) {
		// production to load production pkey
		window.OmiseCard.configure({
			publicKey: omisePublicKeyPROD,
		});
		window.Omise.setPublicKey(omisePublicKeyPROD);
	} else {
		// uat / development to load uat pkey
		window.OmiseCard.configure({
			publicKey: omisePublicKeyUAT,
		});
		window.Omise.setPublicKey(omisePublicKeyUAT);
	}
};
